class TagalysRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  async fetchTagalysRecommendations () {
    if (this._fetched) return
    this._fetched = true

    try {
      const response = await this.getTagalysRecommendations()

      if (response?.products?.length > 0) {
        const cards = await this.createProductCards(response.products)
        this.buildCarousel(cards)
      }
    } catch (error) {
      this.handleError(error)
    }
  }

  getTagalysRecommendations () {
    return new Promise((resolve, reject) => {
      window.Tagalys.APIConnector.Recommendations.call({
        params: {
          recommendationId: this.dataset.widgetId,
          count: this.dataset.limit ? parseInt(this.dataset.limit) : 8,
        },
        onSuccess: (response) => resolve(response),
        onFailure: (error) => reject(error),
      })
    })
  }

  async createProductCards (products) {
    const cards = await Promise.all(
      products.map(async (product) => {
        const productUrl = `${window.Shopify.routes.root}products/${product.handle}`

        try {
          const res = await window.BAO.sectionRenderer.fetchSingle(
            'tagalys-product-card',
            productUrl,
          )
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const article = newDOM.querySelector('article')

          return article
            ? `
              <div
                class="sec-ProductCarousel_Slide keen-slider__slide"
                data-product-carousel-el="slide"
              >
                ${article.outerHTML}
              </div>`
            : ''
        } catch (error) {
          this.handleError(error)
          return ''
        }
      }),
    )

    return cards.join('')
  }

  buildCarousel (cards) {
    this.els.slides.element.innerHTML = cards

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.TAGALYS_CAROUSEL)
      })
    })
  }

  handleError (error) {
    console.error('Error:', error)
  }
}

if (!customElements.get('tagalys-recommendations')) {
  customElements.define('tagalys-recommendations', TagalysRecommendations)
}
